export default {
    isUserLoggedIn: state => {
        return state.loggedIn;
    },

    currentLanguage: state => {
        return state.language;
    },

    userData: state => {
        return state.data;
    }
};
